import React from "react";
import { SectionHeading } from "../site/SectionHeading";
import { TEAM_GROUP_PHOTO, TEAM_BIOS, photoSrcSet } from "@/lib/site-data";

export const Team = () => {
    return (
        <section
            id="equipe"
            className="relative py-24 lg:py-32 bg-white border-y border-brand-line"
            data-testid="team-section"
        >
            <div className="max-w-[1180px] mx-auto px-6 lg:px-10">
                <SectionHeading
                    eyebrow="L'équipe"
                    title={<>Des visages familiers, <span className="italic text-brand-primary">à votre écoute</span>.</>}
                    subtitle="Notre équipe pluridisciplinaire conjugue expertise pharmaceutique, sens du conseil et chaleur humaine — pour vous accompagner à chaque étape."
                />

                {/* Group photo */}
                <figure
                    className="mt-14 lg:mt-16 relative overflow-hidden border border-brand-line"
                    data-testid="team-group-photo"
                >
                    <img
                        src={TEAM_GROUP_PHOTO}
                        srcSet={photoSrcSet(TEAM_GROUP_PHOTO)}
                        sizes="(min-width: 1280px) 1180px, 100vw"
                        alt="L'équipe de la Pharmacie La Lutrive devant la vitrine"
                        className="w-full h-auto block"
                        loading="lazy"
                    />
                </figure>

                {/* Bios grid */}
                <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-10 lg:gap-y-14" data-testid="team-bios">
                    {TEAM_BIOS.map((m) => (
                        <article
                            key={m.name}
                            className="relative"
                            data-testid={`team-bio-${m.name.toLowerCase()}`}
                        >
                            <span
                                aria-hidden
                                className="absolute -left-4 top-1 h-full w-px bg-brand-mint"
                            />
                            <h3 className="font-display text-2xl lg:text-3xl text-brand-ink leading-tight">
                                {m.name}
                            </h3>
                            {m.role && (
                                <p className="mt-1 font-sans text-sm tracking-wide text-brand-primary/90 uppercase">
                                    {m.role}
                                </p>
                            )}
                            <p className="mt-4 font-sans text-[15px] leading-relaxed text-brand-ink/75">
                                {m.bio}
                            </p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Team;
